import { useEffect, useState } from "react";

/** Stor klocka i iOS-stil. Tickar en gång per sekund. */
export function LiveClock({ compact = false }: { compact?: boolean }) {
  const [now, setNow] = useState(() => new Date());

  useEffect(() => {
    const id = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(id);
  }, []);

  const time = now.toLocaleTimeString("sv-SE", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  });
  const seconds = String(now.getSeconds()).padStart(2, "0");
  const date = now.toLocaleDateString("sv-SE", {
    weekday: "long",
    day: "numeric",
    month: "long",
  });

  if (compact) {
    return (
      <span className="tabular text-sm text-muted-foreground">
        {time} · {date}
      </span>
    );
  }

  return (
    <div className="text-center">
      <div className="tabular text-7xl leading-none font-semibold tracking-tight sm:text-8xl">
        {time}
        <span className="text-3xl font-normal text-muted-foreground sm:text-4xl">:{seconds}</span>
      </div>
      <p className="mt-3 text-lg font-medium text-muted-foreground first-letter:uppercase">
        {date}
      </p>
    </div>
  );
}
